import React, { useState, useEffect, useContext } from "react";

import { AppContext } from "../../AppContext";

import ReqControlHeader from "../common/ReqControlHeader";
import RequestTemplateService from "../../services/RequestTemplateService";

import PreTradeEditorComp from "./PreTradeEditorComp";
import LoadingComp from "../common/LoadingComp";
import DateUtil from "../../common/dateUtil";

import PreTradeSearchComp from "./PreTradeSearchComp";

import { fetchCall } from "../../common/FetchHelpers";

const PreTradeComp = () => {

  const finInstituteUrl = "api/trade-request/finInstitute";
  const summaryUrl = "api/trade-request/reqsummary";
  const accountUrl = "api/user-account/ActiveUserAccounts";

  const [appContext, setAppContext] = useContext(AppContext);

// console.log(appContext.appFeature);
// console.log(appContext.appFeature.EMP_PRETRADE_REQUEST_SECURITY_TYPES);
  
  const secTypes = JSON.parse(appContext.appFeature.EMP_PRETRADE_REQUEST_SECURITY_TYPES);
  
  const getDefaultSecurityType = () =>{
    for (var prop in secTypes) {
      if(secTypes[prop])
        return prop;
    }
    return "";
  }
   const defaultSecurityType = getDefaultSecurityType();

// console.log(defaultSecurityType);

  const emptyEditorItem = {
    id:-1,
    securityType: defaultSecurityType,
    cusip: "",
    securitySymbol: "",
    securityDesc: "",
    quantity: "",
    accountNumber: "",
    finInstituteId: "",
    finInstitute: "",
    tradeAction: "",
    tradeDate: "",
    orderType: "",
    limitStop: "",
    timeForce: "",
    liquidationAmount:"",
    account: null,
    dollarAmount:"",

    businessName:"",
    businessDesc:"",
    ownershipShares:"",
    ownershipPercent:"",
    passiveInvolvement:"",
    clientInvolvement:"",
    businessKnowledgeSource:"",
    publicTradeEntity:"",
    businessCustody:"",
    capitalRaiseDesc:"",
    compensationMethod:"",
    custodiedInvestment: "",
    attachments:null
  };



  const [metadata, setMetadata] = useState({});
  const [accounts, setAccounts] = useState({});
  const [showingList, setShowingList] = useState(true);
  const [showingEditor, setShowingEditor] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  const [editorItem, setEditorItem] = useState(emptyEditorItem);
  const [template, setTemplate] = useState("");
  const [editorMode, setEditorMode] = useState("NEW");


  const addNewClickHandler = () => {
    setEditorMode("NEW");
    setEditorItem(emptyEditorItem);

    setControlParam((p) => {
      return { ...p, mode: "add" };
    });

    console.log('Add Clicked');
    setShowingList(false);
    setShowingEditor(true);
  };

  const showListHandler = () => {
    setControlParam((p) => {
      return { ...p, mode: "view" };
    });
    setShowingEditor(false);
    setShowingList(true);
  };

  const handleUpdate=(data)=>{
    //console.log(data);
    setEditorMode("UPDATE");
    const tradeDate = data.tradeDate?DateUtil.toDate(data.tradeDate):null;
      const item = {
        ...data,
        account:{ accountNumber: data.accountNumber, brokerDealerName: data.finInstitute },
        tradeDate
      };
        
      setEditorItem(item);
      setShowingList(false);
      setShowingEditor(true);
  };

  const [controlParam, setControlParam] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
    btnAddLabel: "Create a New Request",
    mode: "view",
    addNewClickHandler,
    showListHandler,
  });


  const fetchTemplate = () => {
    RequestTemplateService.GetPreTrade()
        .then((templateResponse) => {
          if(templateResponse){
            templateResponse.doc = JSON.parse(templateResponse.templateStr);
            setTemplate(templateResponse);
          }
        });
  };

  useEffect(() => {
    fetchTemplate();
    fetchCall(finInstituteUrl)
      .then((result)=>{
        setMetadata({ ...metadata, finInstitute: result });
        setLoading(false);

      },
      (err)=>{
        setLoading(false);
        setShowError(true);
      }
    );
  }, []);

  useEffect(() => {

    fetchCall(summaryUrl)
      .then((result)=>{
        setControlParam({
          ...controlParam,
          approved: result.pretradeRequest.approved,
          pending: result.pretradeRequest.pending,
          rejected: result.pretradeRequest.rejected,
        });
        setLoading(false);

      },
      (err)=>{
        setLoading(false);
        setShowError(true);
      }
    );
  }, [appContext.reloadSummary]);

  
  const getUserAccounts = () => {

    fetchCall(accountUrl)
      .then((result)=>{
        setAccounts(result);
        setLoading(false);

      },
      (err)=>{
        setLoading(false);
        setShowError(true);

      }
    );
 }
  
  useEffect(() => {
    getUserAccounts();
  }, []);


  return (
    <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
      <section className="section-wrapper">
        <div className="page-title">Pre-Trade Requests</div>
        <div className="section-content">
          <ReqControlHeader params={controlParam} />
          <div className="section-body">
            {showingList && <PreTradeSearchComp metadata={metadata} handleUpdate={handleUpdate}/>}
            {showingEditor && (
              <PreTradeEditorComp
                metadata={{ ...metadata, accounts}}
                formData={{...editorItem, template: template}}
                editorMode={editorMode}
                handleClose={showListHandler}
              />
            )}
            {loading && <LoadingComp />}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PreTradeComp;
